import {Component, Input, OnChanges} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {marked} from 'marked';

@Component({
  selector: 'app-markdown',
  imports: [],
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.scss'
})
export class MarkdownComponent implements OnChanges {
  @Input() rawMarkdown = '';
  htmlContent: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {
    marked.setOptions({breaks: true, gfm: true});
  }

  async ngOnChanges() {
    const escaped = this.rawMarkdown.replace(/~/g, '\\~');
    const rawHtml = await marked.parseInline(escaped);
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }
}
